<div class="modal fade" tabindex="-1" role="dialog" #issuesDialog>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="title">
          <h4 class="modal-title">Калькуляция для адреса "{{ destination?.destination.addr }}"</h4>
        </div>
      </div>
      <div class="modal-body">
        <delivery-history [history]="history" [loading]="loading" [productVisible]="false"></delivery-history>
      </div>
    </div>
  </div>
</div>
